(function() {
	var isScriptIsAlreadyPresent = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
	if(!isScriptIsAlreadyPresent){
		/* The default YouTube code which loads the iFrame Player API code asynchronously.*/
		var tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		var userPausedVideo = {};

		/* When API is downloaded, it will automatically call the onYouTubeIframeAPIReady() function
         * This will find every iFrame with the class type of youtube-video and create a separate
         * YT.Player object with its own id, which is derived from the videoId*/
		players = {};
		window.onYouTubeIframeAPIReady = function(){
			var cheeriosVideoWrappers = document.querySelectorAll('.cheerios-video__wrapper');
			if(cheeriosVideoWrappers && cheeriosVideoWrappers.length > 0){
				cheeriosVideoWrappers.forEach(function(elem){
					var videoId = elem.getAttribute('id');
					userPausedVideo[videoId] = false;
					players[videoId] = new YT.Player(videoId,
						{ events: {
								'onReady': onPlayerReady(event, videoId),
								'onStateChange': onPlayerStateChange
							}
						});
				});
			}
		};
	}

	/* When the YT.Player is ready it calls this method, which added listeners
	 * for scrolling and resizing. When these events happen it calls the checkScroll() function.*/
	function onPlayerReady(event, player_id) {

		return function(event) {
			window.addEventListener('scroll', checkScroll(player_id), false);
			window.addEventListener('resize', checkScroll(player_id), false);
		}
	}

	/**
	 * This method determines if the player state was changed by the user or by the automatic video pause function (checkscroll)
	 * This assumes the video will be in 90% view of the user when they are pausing the video (0.9)
	 * @param player
	 */
	function onPlayerStateChange (player) {
		if(player){
			var videoData = player.target.getVideoData();
			if(player.target.getPlayerState() === 2){
				var isVisible = checkIfVideoIsVisible(videoData.video_id,0.9);
				if(isVisible){
					userPausedVideo[videoData.video_id] = true;
				}
			}else if(player.target.getPlayerState() === 1 && userPausedVideo){
				userPausedVideo[videoData.video_id] = false;
			}
		}

	}

	/**
	 * Checks to see if player is visible
	 * @param player_id
	 * @param fraction percentage visible defaults to 0.8 or 80%
	 * @returns {boolean}
	 */
	function checkIfVideoIsVisible(player_id, fraction){
		var video = document.getElementById(player_id);
		fraction = fraction || 0.8;
		var x = 0, y = 0, w = video.offsetWidth,
			h = video.offsetHeight,
			r, // right
			b, // bottom
			visibleX, visibleY, visible, parent;

		parent = video;
		while (parent && parent !== document.body) {
			x += parent.offsetLeft;
			y += parent.offsetTop;
			parent = parent.offsetParent;
		}

		r = x + parseInt(w);
		b = y + parseInt(h);

		visibleX = Math.max(0, Math.min(w, window.pageXOffset
			+ window.innerWidth - x, r - window.pageXOffset));
		visibleY = Math.max(0, Math.min(h, window.pageYOffset
			+ window.innerHeight - y, b - window.pageYOffset));

		visible = visibleX * visibleY / (w * h);

		return (visible > fraction);
	}
	/*This method will calculate if the iFrame YT.Player is currently in view on the user's screen.
     * It uses a loop to check all currently loaded YouTube iframes on the page and based on the calulation
     * will play or pause the iFrame video.*/
	function checkScroll(player_id) {

		return function(event) {
			if (players[player_id]) {
				for (var i = 0; i < Object.keys(players).length; i++) {

					var isVideoVisible = checkIfVideoIsVisible(player_id);

					/* Simple check to only pause or play the video if the
					 * player's current state is playing(1) or paused(2).*/
					if (players[player_id].getPlayerState() == 1 || players[player_id].getPlayerState() == 2) {
						/* If the player is at least 0.8 or greater in view the
						 * player will call the YouTube API playVideo()
						 * function. If not it will call pauseVideo(). */
						if (isVideoVisible && !userPausedVideo[player_id]) {
							players[player_id].playVideo();
						} else {
							players[player_id].pauseVideo();
						}
					}
				}
			}
		}
	}

}());
